import { render, staticRenderFns } from "./lrDepartment.vue?vue&type=template&id=4300dd6f&scoped=true&"
import script from "./lrDepartment.vue?vue&type=script&lang=js&"
export * from "./lrDepartment.vue?vue&type=script&lang=js&"
import style0 from "./lrDepartment.vue?vue&type=style&index=0&id=4300dd6f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4300dd6f",
  null
  
)

export default component.exports